import { EXTRA_PACK_SETS } from './extra-pack.js';
import { ORDINARY_PACK_SETS } from './ordinary-pack.js';
import { EXAM_PACK_SETS } from './exam-pack.js';
const s = (stage, d, w = 3, fill) => fill ? { stage, d, w, fill } : { stage, d, w };
const circle = (cx, cy, r) => `M${cx - r},${cy} a${r},${r} 0 1,0 ${2 * r},0 a${r},${r} 0 1,0 ${-2 * r},0`;
function sentences4(axes, build) {
    const out = [];
    for (const a of axes[0].values) {
        for (const b of axes[1].values) {
            out.push({ text: build(a, b), features: { [axes[0].name]: a, [axes[1].name]: b } });
        }
    }
    return out;
}
// ---------------------------------------------------------------------------
// セット 1: 羽の生えた果物（プロトタイプの絵①）
// ---------------------------------------------------------------------------
const fruitAxes = [
    {
        name: 'body',
        values: ['apple', 'carrot'],
        drawHint: 'りんごは丸い体と葉、にんじんは細長い体と上の葉',
    },
    {
        name: 'arms',
        values: ['one', 'both'],
        drawHint: '片手は左手だけ上げ右手は下ろす、両手は両方上げる',
    },
];
function renderFruit(f) {
    const out = [
        // 左羽
        s(1, 'M136,198 C112,172 72,164 52,186 C36,204 28,246 30,292 C42,276 50,272 56,270 C60,286 66,294 70,296 C76,278 86,270 92,268 C96,284 102,290 106,292 C112,272 122,258 134,250 Z'),
        s(1, 'M128,204 C104,190 82,190 66,200', 2.2),
        s(1, 'M124,220 C98,232 74,258 58,284', 2.2),
        s(1, 'M130,236 C110,250 96,272 88,292', 2.2),
        // 右羽
        s(1, 'M264,198 C288,172 328,164 348,186 C364,204 372,246 370,292 C358,276 350,272 344,270 C340,286 334,294 330,296 C324,278 314,270 308,268 C304,284 298,290 294,292 C288,272 278,258 266,250 Z'),
        s(1, 'M272,204 C296,190 318,190 334,200', 2.2),
        s(1, 'M276,220 C302,232 326,258 342,284', 2.2),
        s(1, 'M270,236 C290,250 304,272 312,292', 2.2),
        // 脚・足
        s(1, 'M188,292 C186,310 184,328 182,346'),
        s(1, 'M212,292 C214,310 216,328 218,346'),
        s(1, 'M182,346 C170,344 160,350 162,358 C170,364 192,362 196,354 C197,349 190,346 182,346 Z'),
        s(1, 'M218,346 C230,344 240,350 238,358 C230,364 208,362 204,354 C203,349 210,346 218,346 Z'),
    ];
    if (f.body === 'carrot') {
        out.push(s(2, 'M200,146 C228,146 260,153 262,173 C259,218 228,279 200,316 C172,279 141,218 138,173 C140,153 172,146 200,146 Z', 3.2), s(2, 'M196,146 C190,128 184,116 176,104'), s(2, 'M200,146 C201,126 203,112 206,98'), s(2, 'M206,146 C214,128 222,116 232,106'), s(2, 'M170,196 L184,204', 2), s(2, 'M228,212 L214,220', 2), s(2, 'M178,246 L192,254', 2));
    }
    else {
        out.push(s(2, 'M200,168 C214,146 258,140 268,186 C276,228 252,290 226,297 C216,300 206,293 200,295 C194,293 184,300 174,297 C148,290 124,228 132,186 C142,140 186,146 200,168 Z', 3.2), s(2, 'M200,166 C201,154 205,142 212,134'), s(2, 'M208,131 L217,136'), s(2, 'M205,144 C190,118 160,110 146,122 C158,140 186,152 205,144 Z'), s(2, 'M150,124 L202,143', 2));
    }
    const carrot = f.body === 'carrot';
    // 左腕（上げる）
    out.push(carrot
        ? s(3, 'M152,222 C140,210 128,192 126,176', 3.4)
        : s(3, 'M142,222 C130,210 120,192 118,174', 3.4), s(3, circle(carrot ? 126 : 118, 164, 10), 3.2));
    if (f.arms === 'both') {
        out.push(carrot
            ? s(3, 'M248,222 C260,210 272,192 274,176', 3.4)
            : s(3, 'M258,222 C270,210 280,192 282,174', 3.4), s(3, circle(carrot ? 274 : 282, 164, 10), 3.2));
    }
    else {
        out.push(carrot
            ? s(3, 'M248,232 C266,246 278,266 280,290', 3.4)
            : s(3, 'M262,228 C280,244 292,266 294,290', 3.4), s(3, circle(carrot ? 282 : 296, 300, 10), 3.2));
    }
    // 顔
    out.push(s(4, circle(183, 206, 12)), s(4, circle(217, 206, 12)), s(4, circle(183, 207, 4), 3, true), s(4, circle(217, 207, 4), 3, true), s(4, 'M174,190 C180,185 188,185 194,189', 2.4), s(4, 'M206,189 C212,185 220,185 226,190', 2.4), s(4, 'M184,238 C192,250 208,250 216,238'), s(4, 'M246,176 C240,186 240,196 246,198 C252,196 252,186 246,176 Z', 2.4));
    return out;
}
// ---------------------------------------------------------------------------
// セット 2: 時計（形 × 置き場所）
// ---------------------------------------------------------------------------
const clockAxes = [
    {
        name: 'place',
        values: ['wall', 'table'],
        drawHint: '壁なら釘とひもで吊るす、テーブルなら机の上に置く',
    },
    { name: 'shape', values: ['round', 'square'], drawHint: '丸い文字盤か四角い文字盤か' },
];
function renderClock(f) {
    const out = [
        // 床・巾木・観葉植物（共通の部屋）
        s(1, 'M28,332 L372,332'),
        s(1, 'M28,344 L372,344', 2),
        s(1, 'M318,332 L326,296 L356,296 L364,332 Z'),
        s(1, 'M341,296 C336,270 322,256 306,250 C320,246 340,258 341,296 Z', 2.4),
        s(1, 'M341,296 C346,268 360,252 378,248 C364,246 344,258 341,296 Z', 2.4),
        s(1, 'M341,296 L341,262', 2.4),
    ];
    const table = f.place === 'table';
    if (table) {
        out.push(s(2, 'M96,244 L304,244 L304,256 L96,256 Z'), s(2, 'M110,256 L108,332'), s(2, 'M290,256 L292,332'), s(2, 'M120,300 L280,300', 2));
    }
    else {
        out.push(s(2, 'M200,104 L200,116', 3.4), s(2, circle(200, 100, 4), 3, true), s(2, 'M200,116 L166,150', 2), s(2, 'M200,116 L234,150', 2));
    }
    const cy = table ? 196 : 200;
    const r = 48;
    if (f.shape === 'square') {
        out.push(s(3, `M${200 - r},${cy - r} L${200 + r},${cy - r} L${200 + r},${cy + r} L${200 - r},${cy + r} Z`, 3.4));
        out.push(s(3, `M${200 - r + 8},${cy - r + 8} L${200 + r - 8},${cy - r + 8} L${200 + r - 8},${cy + r - 8} L${200 - r + 8},${cy + r - 8} Z`, 2));
    }
    else {
        out.push(s(3, circle(200, cy, r), 3.4));
        out.push(s(3, circle(200, cy, r - 8), 2));
    }
    out.push(s(4, `M200,${cy} L200,${cy - 28}`, 3.4), s(4, `M200,${cy} L222,${cy + 10}`, 3.4), s(4, circle(200, cy, 3), 3, true), s(4, `M200,${cy - 36} L200,${cy - 31}`, 2.4), s(4, `M200,${cy + 36} L200,${cy + 31}`, 2.4), s(4, `M164,${cy} L169,${cy}`, 2.4), s(4, `M236,${cy} L231,${cy}`, 2.4));
    return out;
}
// ---------------------------------------------------------------------------
// セット 3: 猫と椅子（位置 × そばの物）
// ---------------------------------------------------------------------------
const catAxes = [
    {
        name: 'place',
        values: ['on', 'under'],
        drawHint: '椅子の座面の上で寝ているか、座面の下で寝ているか',
    },
    { name: 'item', values: ['ball', 'fish'], drawHint: 'そばにボールがあるか、魚があるか' },
];
function renderCat(f) {
    const out = [
        // 椅子
        s(1, 'M120,222 L280,222 L280,236 L120,236 Z'),
        s(1, 'M262,222 L262,100 L278,100 L278,222'),
        s(1, 'M262,124 L278,124', 2.4),
        s(1, 'M262,152 L278,152', 2.4),
        s(1, 'M262,180 L278,180', 2.4),
        s(1, 'M132,236 L132,332'),
        s(1, 'M268,236 L268,332'),
        s(1, 'M30,332 L370,332', 2.4),
    ];
    const under = f.place === 'under';
    const by = under ? 306 : 198; // 体の中心 y
    const hy = by - 16;
    out.push(s(2, `M136,${by} a54,24 0 1,0 108,0 a54,24 0 1,0 -108,0`, 3.2), s(2, circle(148, hy, 22), 3.2), s(2, `M244,${by} C274,${by - 10} 280,${by - 36} 262,${by - 46}`, 3), s(2, `M130,${hy - 14} L134,${hy - 32} L146,${hy - 20}`), s(2, `M164,${hy - 20} L176,${hy - 32} L178,${hy - 14}`));
    if (f.item === 'fish') {
        out.push(s(3, 'M46,314 C62,296 92,296 108,314 C92,332 62,332 46,314 Z', 3.2), s(3, 'M46,314 L30,300 L30,328 Z', 3), s(3, circle(96, 311, 3), 3, true), s(3, 'M70,302 C74,310 74,318 70,326', 2));
    }
    else {
        out.push(s(3, circle(70, 312, 20), 3.2), s(3, 'M54,300 C66,308 74,320 78,330', 2), s(3, 'M60,328 C64,316 74,306 88,300', 2));
    }
    out.push(s(4, `M136,${hy} C140,${hy - 4} 146,${hy - 4} 150,${hy}`, 2.4), s(4, `M154,${hy} C158,${hy - 4} 164,${hy - 4} 168,${hy}`, 2.4), s(4, `M150,${hy + 8} C152,${hy + 12} 156,${hy + 12} 158,${hy + 8}`, 2.4), s(4, `M122,${hy + 4} L138,${hy + 6}`, 2), s(4, `M122,${hy + 12} L138,${hy + 10}`, 2), s(4, `M172,${hy + 6} L188,${hy + 4}`, 2), s(4, `M172,${hy + 10} L188,${hy + 12}`, 2), s(4, `M180,${by - 40} C186,${by - 46} 188,${by - 54} 184,${by - 60}`, 2), s(4, `M190,${by - 52} C198,${by - 58} 200,${by - 68} 194,${by - 76}`, 2));
    return out;
}
export const LEGACY_PACK_SETS = [
    {
        id: 'pack-winged-fruit',
        level: 1,
        scene: 'A cartoon fruit or vegetable character with wings, standing on two legs.',
        axes: fruitAxes,
        sentences: sentences4(fruitAxes, (body, arms) => `The ${body} with wings is raising ${arms === 'one' ? 'one hand' : 'both hands'}.`),
        source: 'pack',
        render: renderFruit,
    },
    {
        id: 'pack-clock-room',
        level: 1,
        scene: 'A room with a clock and a potted plant.',
        axes: clockAxes,
        sentences: sentences4(clockAxes, (place, shape) => `The ${shape} clock is on the ${place}.`),
        source: 'pack',
        render: renderClock,
    },
    {
        id: 'pack-cat-chair',
        level: 1,
        scene: 'A cat sleeping near a chair, with something on the floor next to it.',
        axes: catAxes,
        sentences: sentences4(catAxes, (place, item) => `The cat is sleeping ${place} the chair, next to a ${item}.`),
        source: 'pack',
        render: renderCat,
    },
    ...EXTRA_PACK_SETS,
];
export { ORDINARY_PACK_SETS, EXAM_PACK_SETS };
export const ALL_PACK_SETS = [
    ...LEGACY_PACK_SETS,
    ...ORDINARY_PACK_SETS,
    ...EXAM_PACK_SETS,
];
export const PACK_SETS = EXAM_PACK_SETS;
const byId = new Map(ALL_PACK_SETS.map((set) => [set.id, set]));
export function getPackSet(id) {
    return byId.get(id);
}
export function renderPackDrawing(set, correctIndex) {
    const sentence = set.sentences[correctIndex];
    if (!sentence)
        throw new Error(`invalid correctIndex ${correctIndex}`);
    return { setId: set.id, correctIndex, strokes: set.render(sentence.features), source: 'pack' };
}
/** SentenceSet としてのビュー（render を含まない） */
export function packAsSet(p) {
    return {
        id: p.id,
        family: p.family,
        level: p.level,
        scene: p.scene,
        sentences: p.sentences,
        axes: p.axes,
        source: 'pack',
    };
}
//# sourceMappingURL=pack.js.map